import React from "react";
import PropTypes from "prop-types"
import styled from "@emotion/styled";

import {ReactComponent as HexagonBackground} from "../../assets/HexagonShadow.svg";


const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 3px;
    justify-content: center;
    width: fit-content;
`;

const DrawerIconWrapper = styled.div`

    margin-top: 10px;
    margin-bottom: 15px;
    z-index: 1000;
    
    width: 84px;
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    svg, svg > * {
      fill: ${(props) => (props.selected) ? "var(--accent);" : "var(--accent-text);"};
    }
`;

/**
 * http://brenna.github.io/csshexagon/
 * Css Hexagon creator.
 */
// eslint-disable-next-line no-unused-vars
const IconBackground = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    
    width: 40px; 
    height: 23.09px;
    background-color: #ffffff;
    margin: 20px;
    box-shadow: 0px -2px 20px 0px rgba(0,0,0,0.1), 3px 6px 10px 0px rgba(0,0,0,0.06);
    
    :before,
    :after {
      content: "";
      position: absolute;
      width: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
    }
    
    :before {
      bottom: 100%;
      border-bottom: 11.55px solid #ffffff;
    }
    
    :after {
      top: 100%;
      width: 0;
      border-top: 11.55px solid #ffffff;
    }
    
    
    svg; svg > path {
      fill: ${(props) => (props.selected) ? "var(--accent);" : "var(--accent-text);"};
    }
    
`;


const IconLabelWrappers = styled.div`
    /* text-xs/Medium */
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    font-family: 'Metropolis',serif;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    user-select: none;
    
    /* company */
    color: ${(props) => (props.selected) ? "#002A95;" : "white;"};
`;


export default function SideDrawerItem(props) {

    const {onIconClick, isSelected, DrawerIcon, iconLabel} = props;

    return <DrawerIconWrapper onClick={onIconClick} selected={isSelected}>
        {/*<IconBackground selected={isSelected}>*/}
        {/*    <DrawerIcon*/}
        {/*        style={{*/}
        {/*            margin: "auto"*/}
        {/*        }}*/}
        {/*    />*/}
        {/*</IconBackground>*/}

        <IconWrapper>
            <HexagonBackground/>
            <DrawerIcon
                style={{
                    position: "absolute",
                    marginTop: "-5px",
                    userSelect: "none"

                }}/>
        </IconWrapper>

        {
            !isSelected && <IconLabelWrappers>
                {iconLabel}
            </IconLabelWrappers>
        }
    </DrawerIconWrapper>
}


SideDrawerItem.propTypes = {
    onIconClick: PropTypes.func,
    isSelected: PropTypes.bool,
    DrawerIcon: PropTypes.any,
    iconLabel: PropTypes.string
};

